var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#E6F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.43555L8.67 8.72972V15.7495L3 12.5635V5.43555Z",
    fill: "#BB844E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67 2.25L14.34 5.436L8.67 8.73L3 5.436L8.67 2.25Z",
    fill: "#DAA779"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3398 5.43555L8.66984 8.72972V15.7495L14.3398 12.9955L14.3398 5.43555Z",
    fill: "#F4B67E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70016 8.45979H5.16016V6.67779L10.7222 3.38379L12.1262 4.19379L6.51016 7.48779V9.26979L5.70016 8.45979Z",
    fill: "#FDE7CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEntry);
export default __webpack_public_path__ + "static/media/No Entry.81addcf9448ac71677f4510dcc96a48e.svg";
export { ForwardRef as ReactComponent };